import { http } from '../../core/services/http';
import transformHolidays from './transformHolidays';

const loadHolidays = () =>
  http.get('holidaycalendar/nextyears/1').then(response => transformHolidays(response.data.holidays));

export default loadHolidays;
